import { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react/index'

import { withRouter } from 'next/router'
import Layout from '../components/Layout'
import Footer from '../components/Footer'
import BlogHeader from '../components/Blog/BlogHeader'
import PostPreview from '../components/PostPreview'
import PostGrid from '../components/PostGrid'
import { withTranslation } from '../i18n'

import {
  BlogContent, BlogTitle
} from '../styles/blogStyles'
import { redirectByEnLang } from './podcast'

@inject('store')
@observer
class Mag extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    store: PropTypes.instanceOf(Object).isRequired,
    i18n: PropTypes.instanceOf(Object).isRequired,
    router: PropTypes.instanceOf(Object).isRequired,
    categories: PropTypes.arrayOf(PropTypes.string)
  }

  static defaultProps = {
    categories: []
  }

  static getInitialProps({ query }) {
    const categories = query.category ? [query.category] : []
    return {
      categories,
      namespacesRequired: ['magazine', 'common', 'auth', 'reset-password', 'contacts']
    }
  }

  getData() {
    const {
      i18n: { language }, categories, store
    } = this.props
    const query = { categories, promo: true }
    store.loadPromoPost({ language, query })
  }

  componentDidMount() {
    this.getData()
    redirectByEnLang(this.props.i18n.language, this.props.router.replace)
  }

  componentDidUpdate(prevProps) {
    redirectByEnLang(this.props.i18n.language, this.props.router.replace)
    if (this.props.i18n.language !== prevProps.i18n.language || this.props.categories !== prevProps.categories) {
      this.getData()
    }
  }

  render() {
    const { t, categories, store: { promoPost } } = this.props
    return (
      <Layout meta={{ title: t('common:PAGE_MAG_SEO_TITLE'), description: t('common:PAGE_MAG_SEO_DESC') }}>
        <BlogHeader />
        <BlogContent className="content" promoId={promoPost && promoPost.id}>
          {promoPost && <PostPreview promo post={promoPost} />}
          <BlogTitle>{t('latest-updates')}</BlogTitle>
          <PostGrid categories={categories} />
        </BlogContent>
        <Footer />
      </Layout>
    )
  }
}
const WithRouter = withRouter(Mag)
export default withTranslation(['magazine', 'common', 'auth', 'reset-password', 'contacts'])(WithRouter)
